module.exports = __webpack_public_path__ + "static/media/25.29011060.JPG";